import trim from 'lodash/trim';

import {CommonUserProperties, MPProperties} from 'common/constants';

export const AVATAR_PROPERTIES = [MPProperties.Avatar, MPProperties.Email];

export const NAME_PROPERTIES = [
  MPProperties.Name,
  MPProperties.FirstName,
  MPProperties.LastName,
  CommonUserProperties.Name,
  CommonUserProperties.FirstName,
  CommonUserProperties.LastName,
];

export interface ProfileNameProperties {
  [MPProperties.Name]?: string;
  [MPProperties.FirstName]?: string;
  [MPProperties.LastName]?: string;
  [CommonUserProperties.Name]?: string;
  [CommonUserProperties.FirstName]?: string;
  [CommonUserProperties.LastName]?: string;
}

export function getUserName(properties: ProfileNameProperties, defaultName): string {
  const nameProperty = properties[MPProperties.Name] ?? properties[CommonUserProperties.Name];

  if (nameProperty) {
    return nameProperty;
  }

  const first = properties[MPProperties.FirstName] ?? properties[CommonUserProperties.FirstName] ?? ``;
  const last = properties[MPProperties.LastName] ?? properties[CommonUserProperties.LastName] ?? ``;

  if (first || last) {
    return trim(first + ` ` + last);
  }

  return defaultName;
}
